import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import React, { FC } from 'react';
import style from './index.module.scss';

interface Props extends ModalProps {
  title?: string;
  visible: boolean;
  onOk?: (e: React.MouseEvent<HTMLElement>) => void;
  icon?: React.ReactNode;
  confirmTitle?: React.ReactNode;
  confirmPrompt?: React.ReactNode;
}

export const ConfirmModal: FC<Props> = (props) => {
  const { title, visible, onOk, icon, onCancel, confirmTitle, confirmPrompt } = props;
  return (
    <Modal
      centered
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={480}
      className={style.confirmModal}
      maskClosable={false}
      okText={'确定'}
      cancelText={'取消'}
      title={<div className={style.title}>{title}</div>}
    >
      <div className={style.confirmModalMain}>
        <div className={style.confirmModalIcon}>{icon}</div>
        <div className={style.confirmModalContent}>
          <div className={style.confirmTitle}>{confirmTitle}</div>
          <div className={style.confirmPrompt}>{confirmPrompt}</div>
        </div>
      </div>
    </Modal>
  );
};
